import { render, staticRenderFns } from "./HsStudentsChangeLogs.vue?vue&type=template&id=944382d2&"
import script from "./HsStudentsChangeLogs.vue?vue&type=script&lang=js&"
export * from "./HsStudentsChangeLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports